import { Component, Prop, h } from '@stencil/core';
import clsx from 'clsx';

@Component({
  tag: 'ds-link',
  styleUrl: 'ds-link.scss'
})
export class Link {
  @Prop() href: string;
  @Prop() target?: string;
  @Prop() type?: 'primary' | 'secondary' | 'standard' | 'inherit' = 'primary';
  @Prop() label?: string;
  @Prop() linkTitle?: string;

  render() {
    return (
      <a
        class={clsx('link', `--${this.type}`)}
        href={this.href}
        target={this.target}
        aria-label={this.label}
        title={this.linkTitle}
      >
        <slot></slot>
      </a>
    );
  }
}
